// ============================================================================
// TASSONOMIA ATTIVITÀ — Rischio (Non Sanitario / Sanitario) → Settore → Tipo
// ----------------------------------------------------------------------------
// Trascritta dagli screenshot ufficiali della piattaforma compagnia.
// Struttura reale:
//   1) Regime di rischio: "Rischio Non Sanitario" oppure "Rischio Sanitario"
//   2) Settore Principale (12 settori, uguali per i due regimi)
//   3) Tipo Principale (dipende da regime + settore)
//
// Flag per "Tipo" esclusi Art.34:
//   excluded: true     -> attività esclusa (blocca il preventivo)
//   conditional: true  -> esclusa SOLO se NON gestita da cooperativa
//                         (se la forma giuridica contiene "coop" non si applica)
// Modifica liberamente label e flag se la compagnia aggiorna gli elenchi.
// ============================================================================

export const REGIMI = ["Rischio Non Sanitario", "Rischio Sanitario"];

export const SETTORI = [
  "Altro ente del terzo settore - altra organizzazione non profit",
  "Associazione di promozione sociale (APS)",
  "Consorzio Imprese/coop sociali",
  "Ente Religioso",
  "Ente filantropico - fondazione",
  "Enti sportivi",
  "Impresa impatto (Società di persone/capitali diversa da impresa sociale/cooperativa sociale)",
  "Impresa sociale, compresa cooperativa sociale",
  "Organizzazione di volontariato (ODV) - Associazione riconosciute / non riconosciute",
  "Parrocchie",
  "Rete associativa",
  "Società di mutuo soccorso",
];

// Lista NON sanitaria condivisa dalla maggior parte dei settori.
const NON_SANITARIO_TIPI = [
  "Abbigliamento",
  "Agenzie e studi fotografici",
  "Alimentari in genere",
  "Assemblaggio e confezionamento per conto terzi",
  "Attività commercializzazione olio sfuso",
  "Attività di formazione e consulenza",
  "Attività di produzione beni alimentari",
  "Attività di produzione beni settore carta, cartotecnica, grafica",
  "Attività di servizi con inserimenti lavorativi (Formazione professionale)",
  "Attività lattiero casearia",
  "Attività ortofrutticola",
  "Attività sociali, aggregative, ricreative, culturali, educative, ambientali e turistiche (Accompagnamento e trasporto di alunni, disabili, persone)",
  "Attività socio-educative, formative e socio-culturali e socio-assistenziali",
  "Attività vitivinicola",
  "Aziende di servizi (di comunicazione, finanziarie esempio Etica SGR, mag)",
  "Bar (compresa rivendita tabacchi e/o valori e/o ricevitoria)",
  "Birrifici e/o Birrerie",
  "Borse e borsette",
  "Caffè",
  "Calzature (vendita) calzolai",
  "Calzature in genere (produzione)",
  "Cancelleria, cartoleria (esclusi pirici)",
  "Commercio e vendita di prodotti",
  "Comunità alloggio, assistenziale, di tipo residenziale, di tipo familiare, convitti",
  "Comunità energetiche",
  "Cooperativa di consumo",
  "Cooperativa di dettaglianti",
  "Drogherie",
  "Erboristerie",
  "Facchinaggio e traslochi",
  "Falegnameria, metalmeccanica (fabbricazione e lavorazione di oggetti in metallo)",
  "Fiori e piante",
  "Gestione di laboratori di avviamento al lavoro, formazione professionale",
  "Gestione di: centri diurni educativi, riabilitativi, ricreativi, di aggregazione, di prima accoglienza, centri sociali e colonie",
  "Giocattoli esclusi pirici",
  "Idraulici, installatori e manutentori di impianti idraulici, termici, elettrici, di riscaldamento, di refrigerazione, di condizionamento",
  "Impianti e/o pannelli fotovoltaici e/o solari (inclusa installazione presso terzi)",
  "Lavanderie (escluse self service o a gettone)",
  "Librerie",
  "Manutenzione del verde",
  "Manutenzione del verde, floricoltura, giardinaggio, vivaismo (compreso abbattimento e potatura di alberi)",
  "Manutenzione del verde, floricoltura, giardinaggio, vivaismo (escluso abbattimento e potatura di alberi)",
  "Panetterie, pasticcerie, minimarket",
  "Pastifici, paste alimentari, cereali, riso, legumi",
  "Preparazione pasti (servizi di refezione e ristorazione)",
  "Pulizie locali, fabbricati ecc",
  "Raccolta rifiuti, gestione isole ecologiche",
  "Restauratori, decoratori di mobili e cornici",
  "Ristoranti, Pizzerie anche d'asporto, trattorie, tavole calde, catering, gestione cucine presso terzi",
  "Sartorie",
  "Scuole materne, asili nido, assistenza scolastica e doposcuola, attività ludico/assistenziale/educativa",
  "Serramenti e infissi inclusa installazione presso terzi",
  "Serramenti, palchetti compresa rimozione, manutenzione e posa",
  "Servizi turistici (esempio gestione rifugi, accompagnamento turisti)",
  "Sportelli informativi, centri servizi, corsi di formazione informatica e/o per attività amministrative",
  "Stabilimenti di confezionamento, imbottigliamento, imballaggio",
  "Strumenti musicali e accessori (compreso il noleggio)",
  "Tipografia, rilegatoria",
  "Tutela ambientale (gestione di oasi)",
].map((label) => ({ label }));

const SPORT_TIPI = [
  { label: "Organizzazione e gestione di attività sportive dilettantistiche" },
  { label: "Organizzazione e gestione di attività sportive dilettantistiche Rischio 1", risk_class: "1" },
  { label: "Organizzazione e gestione di attività sportive dilettantistiche Rischio 2", risk_class: "2" },
  { label: "Organizzazione e gestione di attività sportive dilettantistiche Rischio RD", risk_class: "3" },
];

const PARROCCHIE_TIPI = [
  { label: "Attività religiose, pastorali, educative e formative, sociali e assistenziali, ricreative, sportive e culturali" },
];

// Lista SANITARIA condivisa. Esclusioni Art.34 marcate con flag.
const SANITARIO_TIPI = [
  { label: "Assistenza infermieristica e socio sanitaria domiciliare o presso strutture terzi" },
  { label: "Case di accoglienza, case famiglia, centri di reinserimento sociale" },
  { label: "Case famiglia, comunità alloggio" },
  { label: "Poliambulatori, ambulatori e studi medici", excluded: true },
  { label: "Servizi di ambulanza con personale sanitario" },
  { label: "Servizi di assistenza diurna per minori disabili" },
  { label: "Servizi di assistenza sociale con l'ausilio di esercenti la professione sanitaria" },
  { label: "Strutture e centri di accoglienza, dormitori / ricoveri per senza dimora anche strutture di accoglienza per immigrati / rifugiati" },
  { label: "Strutture residenziali di assistenza per anziani, RSA e case di riposo", excluded: true, conditional: true },
  { label: "Strutture residenziali e semiresidenziali a esclusione di quelle a doppia diagnosi, comunità ad alta intensità e RSA, Case di Riposo" },
  { label: "Strutture residenziali per pazienti psichiatrici, con doppia diagnosi e comunità ad alta intensità" },
  { label: "Studi veterinari o strutture che si avvalgono di veterinari" },
];

const SPORT = "Enti sportivi";
const PARROCCHIE = "Parrocchie";

// Ritorna l'elenco dei Tipo Principale per regime + settore.
export function tipiFor(regime, settore) {
  if (!regime || !settore) return [];
  if (regime === "Rischio Sanitario") return SANITARIO_TIPI;
  if (settore === SPORT) return SPORT_TIPI;
  if (settore === PARROCCHIE) return PARROCCHIE_TIPI;
  return NON_SANITARIO_TIPI;
}

// Ritorna { label, conditional } se il Tipo selezionato è escluso (Art.34),
// tenendo conto della deroga cooperative, altrimenti null.
export function tipoExclusion(regime, settore, tipoLabel, formaGiuridica = "") {
  const tipo = tipiFor(regime, settore).find((t) => t.label === tipoLabel);
  if (!tipo || !tipo.excluded) return null;
  const isCoop = (formaGiuridica || "").toLowerCase().includes("coop");
  if (tipo.conditional && isCoop) return null;
  return { label: tipo.label, conditional: !!tipo.conditional };
}
